<template>
    <div>
        <b-row>
            <b-col sm="12" md="12">
                <vue-cal :selected-date="startDate"
                         :time-cell-height="65"
                         :time-step="60"
                         :disable-views="['years', 'year', 'month', 'days', 'day']"
                         :events="timetables"
                         :locale="$i18n.locale"
                         :time-from="timeFrom"
                         :time-to="timeTo"
                         @cell-click="selectDate"
                         :on-event-click="eventClick">
                            <template #event="{ event }">
                                <div
                                    class="vuecal__event-title"
                                    :style="{ backgroundColor: event.color, color: '#000' }"
                                    v-html="event.title"
                                ></div>
                                <div>
                                    <i class="ri-time-line"></i> {{ setTime(event.start) }}
                                </div>
                                <div>
                                    {{ event.content }}
                                </div>
                            </template>
                </vue-cal>
            </b-col>
        </b-row>
    </div>
</template>
<script>

//Components
import {ValidationObserver, ValidationProvider} from "vee-validate"
import SelectDate from "@/components/interactive-fields/SelectDate"
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import '/src/locales/tr/vuecal.js'
import moment from "moment"

//Services
import PcgcService from "@/services/PcgcService"
import qs from "qs";




export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        SelectDate,
        VueCal
    },

    data() {
        return {
            formData: {},
            timeFrom: 9 * 60,
            timeTo: 19 * 60,
            startDate: null,
            timetables: [],
        }
    },

    created() {
        this.getDates()
    },

    methods: {
        getDates(){
            this.timetables = []
            let user = this.$store.getters['auth/getUser']
            const config = {
                params: {
                    filter: {
                        psychologist_id: user.id
                    }
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
            PcgcService.getAllAppointment(config).then(response => {
                response.data.data.forEach(item => {
                    this.timetables.push({
                        start: item.appointment_date + ' ' + item.appointment_time.substring(0,2)+':00',
                        end: item.appointment_date + ' ' + (parseInt(item.appointment_time.substring(0,2))+1)+':00',
                        title: item.psychologist_name+' '+item.psychologist_surname,
                        content: this.getLocaleText(item, 'status_name'),
                        id: item.id,
                        style: 'background-color: #87CEFA',
                    })
                })
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        selectDate(event){
            if(!this.checkPermission('psychologistappointment_store')) {
                this.$toast.error(this.$t('unauthorized_operation'))
                return false
            }
            let dateR = moment(event).format('YYYY-MM-DD')
            let time = moment(event).format('HH:00')
            this.$swal.fire({
                title: this.$t('confirmation'),
                text: this.$t('pcgc_select_date_info',{date: dateR, time: time+':00'}),
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no'),
            }).then((result) => {
                if (result.isConfirmed) {
                    let formData = {
                        appointment_date: dateR,
                        appointment_time: time,
                    }
                    PcgcService.addAppointment(formData).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.getDates()
                    }).catch(e => {
                        this.showErrors(e, null)
                    })
                }
            })

        },

        setTime(time){
            return moment(time).format('HH:mm')
        },

        eventClick(event){
            if(!this.checkPermission('psychologistappointment_delete')) {
                this.$toast.error(this.$t('unauthorized_operation'))
                return false
            }
            let dateR = moment(event.start).format('DD-MM-YYYY')
            let time = moment(event.start).format('HH')
            this.$swal.fire({
                title: this.$t('confirmation'),
                text: this.$t('pcgc_select_date_remove_info',{date: dateR, time: time+':00'}),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no'),
            }).then((result) => {
                if (result.isConfirmed) {
                    PcgcService.deleteAppointment(event.id).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.getDates()
                    }).catch(e => {
                        this.showErrors(e, null)
                    })
                }
            })
        }
    },
};
</script>

